const subConfig =
  REACT_APP_ENV === 'live'
    ? {
        appId: '85e80adc3795147182c681ce7e69cbb9',
        secretKey: 'debd7036cbd4a88c1dd0f5cb83c0e832',
        publicKey:
          '-----BEGIN PUBLIC KEY-----' +
          'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAssAOqkyTje' +
          'H2A5OJBQducDPKC/J06hSraWQDvVtlVCPAqa8Jqnsv1x5Kb4i69WM7' +
          'GAis/EsjPYKEyxy6JEcCiZPqDpK2Poi8CwOvknD+reSQ9aCbqWkGPi' +
          'eRc8mYq8LgTzZtp0B2iiv4IcYHCWLdj/5lUIMmLe7fdMP9wo5+W3Xl' +
          'pBAcHyH+VJ3xzq/AaSR1JM4XEvQSLoMSnI2SW9Tusl3feUEB/iJVpu' +
          'oZ7lm9zWwcHmrHhCCuXuxdAoz6tG4jFBa2qK/OaI/EYzftBBsjdaH0' +
          'Od3IZUHfSJ2GHhzo1CEXONs8PpM1m47yaNVHhhMS/TZRR1url4/pR0' +
          'DwA7xFAwIDAQAB' +
          '-----END PUBLIC KEY-----',
      }
    : {
        appId: 'abf227432f9935a0a0dad51c5338a825',
        secretKey: '36f752f5c3733f83e3b0484c340bfd90',
        publicKey:
          '-----BEGIN PUBLIC KEY-----' +
          'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArnOzprxuryHHITI9oAL4' +
          '7FERvLyX5wPbE5Qy0q4vwnlj53zvAWXFfJ56/HJ9uoUMMu3Nz20SKt2vkXZ+1bcT' +
          'u3gUVnLZt+8c1Qmt2x5UFSj+Ip9Muc0CFr16ZYx9FMitabZO3dbe0qUH1+1x04Pf' +
          'pHDw2yCF4KpLTDfMmPBbmbs85RG1X6a0TrTpaFmvM+kl8Xr/yf3pamnGEaDNIBnL' +
          'WfR1er308DBXETOef3enx2/derbLJiQsWNQ3xWZZmhcUzRA6CuES/yZPndsmSIJp' +
          'CSxqPKqhibfVFacHYfXJ2PzDzVXM9SBp5lLZLkRI5L0rLq8CPQ8lULFDnvV0KmF9' +
          'WQIDAQAB' +
          '-----END PUBLIC KEY-----',
      };

const userSecConfig =
  REACT_APP_ENV === 'live'
    ? {
        appId: 'dd47a5f3a6f0e6272d5b55ee53acfaff',
        secretKey: '9eb694c0f95ad4c32885ae313e008ed2',
        publicKey:
          '-----BEGIN PUBLIC KEY-----' +
          'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAk+UdraRHEM0kZPxDfk2IR0cSucOz9nJBbdT+1+UjJPWdUNH2WX4GX74mgap5F74o7PAEztMl94YYHsDk/NybM0e1Q6hFNTs1HrzJyYBvbdr1l5Ehv2YYriHjBpGSom/g3sWMXItRf/0LPHNdRrDWKm7+/hYgFGj2+Rqcwb36M8GC96pRNvjJTps1YuZ9WVXItCp/x5IBqP0VIQcSXG6IyvK8PD5laeKZW5PYav0gefNd+yTJ0s7ttnyxwMJSKmC41Zvs8QoUoe+KVDEOGnT5eOABSozxB9od41pX7wQhBhizp7za1KRLJXM5PWuD3UetGVkVattTuEkOi7IJH42BvQIDAQAB' +
          '-----END PUBLIC KEY-----',
      }
    : {
        appId: '0cc11bf6d54b1f5f0344131cc4831761',
        secretKey: '5d7d1eb597c32fe6e3f9b7b8f133eac7',
        publicKey:
          '-----BEGIN PUBLIC KEY-----' +
          'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA9tCqAjzKAB2I+Vok7H/7AZDRW39MafhEsk2SldqfyUP7sFLnAzp/h5Z7ga+U/z04x8Y5y4dKtyMgVaeiAoHrGlR1Qt1NBgYn1DPyaRxypFKgZxSjHya/2PsUDHgkagZoHueaUg8a9E644DgUY7k+6vh6AiOEPOhcZF7WsCYbw+QIy/+a+aHe/Yp3/5t4MFDhe3tEIYyHX/5yHytuf3/pWimVrBetGZmtV5TnhVtnZljHfek1O/m6TQD4BDSi7rC0TCUfa8BbveQcTGvU6TsW+CHBzenNN3wqEL/4x4Wpux8Csd2dELoIgDRP7gNlpPBrk2TuIbSc6zVliSUM/vJbiQIDAQAB' +
          '-----END PUBLIC KEY-----',
      };

const envConfig = (() => {
  // mock, dev, test1, reg
  if (['mock', 'reg'].indexOf(REACT_APP_ENV) >= 0) {
    let env = 'env3';
    switch (REACT_APP_ENV) {
      case 'reg':
        env = 'reg';
        break;
      case 'mock':
      default:
        env = 'env3';
        break;
    }
    // const env = REACT_APP_ENV === 'test1' ? 'env1' : 'env3';
    return {
      iconPreUrl: `https://fastescrow-h5-${env}.test.scredit.com.my`,
    };
  }

  if (REACT_APP_ENV === 'test1' || REACT_APP_ENV === 'staging') {
    // staging
    return {
      iconPreUrl: `https://fastescrow-h5.staging.scredit.com.my`,
    };
  }

  // live
  if (REACT_APP_ENV === 'live') {
    return {
      iconPreUrl: `https://cdn.scredit.sg/${BIZ_COUNTRY}/fastescrow-h5/live`,
    };
  }

  // stable&dev
  if (['dev', 'stable'].includes(REACT_APP_ENV)) {
    return {
      iconPreUrl: `https://fastescrow-h5.test-stable.scredit.com.my`,
    };
  }

  // test, uat
  return {
    iconPreUrl: `https://fastescrow-h5.${REACT_APP_ENV}.scredit.com.my`,
  };
})();

const dependDomain = (() => {
  switch (REACT_APP_ENV) {
    case 'mock':
    case 'dev':
      return {
        // ucDomain: 'https://uc-h5-env3.test.scredit.com.my',
        // financeDomain: 'https://finance-env3.test.scredit.com.my',
        ucDomain: 'https://uc-h5.test-stable.scredit.com.my',
        financeDomain: 'https://finance.test-stable.scredit.com.my',
      };
    // TODO: need to update
    case 'stable':
      return {
        ucDomain: 'https://uc-h5.test-stable.scredit.com.my',
        financeDomain: 'https://finance.test-stable.scredit.com.my',
      };
    case 'test':
      return {
        ucDomain: 'https://uc-h5.test.scredit.com.my',
        financeDomain: 'https://finance.test.scredit.com.my',
      };
    case 'test1':
    case 'staging':
      return {
        ucDomain: 'https://uc-h5.staging.scredit.com.my',
        financeDomain: 'https://finance.staging.scredit.com.my',
      };
    case 'reg':
      return {
        ucDomain: 'https://uc-h5-reg.test.scredit.com.my',
        financeDomain: 'https://finance-reg.test.scredit.com.my',
      };
    case 'uat':
      return {
        ucDomain: 'https://uc-h5.uat.scredit.com.my',
        financeDomain: 'https://finance.uat.scredit.com.my',
      };
    case 'live':
    default:
      return {
        ucDomain: 'https://uc-h5.scredit.com.my',
        financeDomain: 'https://finance.scredit.com.my',
      };
  }
})();

const config = {
  platForm: 1,
  version: 1,
  region: 'my',
  fastEscrowVersion: 'fastescrow_v1.0.0.100',
  userSecConfig,
  ...subConfig,
  ...envConfig,
  ...dependDomain,
};

export default config;
